import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AuthLayout from '../components/AuthLayout';
import { ROUTE_LOGIN } from '../constants'
import { showErrorMessage, showSuccessMessage } from '@/shared/components/toast-system';
import { validateField } from '../utils/validationUtils';
import { forgotPassword } from '../utils/apiUtils';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let error = validateField({ isRequired: true, maxLength: 100, isEmail: true }, email, 'Email');
    if (error) {
      showErrorMessage(error);
      return;
    }

    setIsLoading(true);

    try {
      const response = await forgotPassword({ email });
      if (response.status === 202) {
        showSuccessMessage('User is not registered, please check your email to complete the registration process');
      } else if (response.status === 200) {
        showSuccessMessage('Reset link sent. Check your email for the password reset link.');
      }
      setIsSubmitted(true);
    }
    catch (error) {
      console.error('unable to process your request. Please try again', error);
      showErrorMessage('unable to process your request. Please try again');
    } finally {
      setIsLoading(false);
    }
  }

  if (isSubmitted) {
    return (
      <AuthLayout
        icon={<img src="/images/logo_trans.png" alt="TypeHero" className="auth-logo" />}
        title="Check your email"
      >
        <div className="auth-stack">
          <p style={{ fontSize: '14px', color: '#6b7280', textAlign: 'center' }}>
            Click the link in the email to reset your password. If you don't see it, check your spam folder.
          </p>
          
          <div className="pt-2">
            <button
              type="button"
              className="auth-button-outline"
              onClick={() => {
                setIsSubmitted(false);
                setEmail('');
              }}
            >
              Try a different email
            </button>
          </div>
          
          <div className="pt-2">
            <Link to={ROUTE_LOGIN} className="auth-link-back">
              <ArrowLeft size={16} className="auth-link-icon" />
              Back to login
            </Link>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      icon={<img src="/images/logo_trans.png" alt="TypeHero" className="auth-logo" />}
      title="Reset your password"
    >
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="input-group">
          <label htmlFor="email" className="input-label">Email address</label>
          <input
            type="email"
            id="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            className="input-field"
            required
          />
        </div>

        <div className="pt-2">
          <button
            type="submit"
            className="auth-button"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send reset link'}
          </button>
        </div>

        <div className="pt-2 text-center">
          <Link to={ROUTE_LOGIN} className="auth-link-back">
            <ArrowLeft size={16} className="auth-link-icon" />
            Back to login
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}
export default ForgotPassword;